<template>
  <app-panel
    data-cy-next-session-enrolment
    :suptitle="$t('course.page.next_session_enrolment.title')"
  >
    <course-session-remaining-seats-chip
      class="!absolute -top-2 right-4"
      :session="session"
    />

    <template #title>
      <span class="text-3xl" data-cy-date>
        {{ useCourseSessionInfo(session).formattedDate.value }}
      </span>
    </template>

    <template #subtitle>
      <course-page-session-chip-info
        v-if="session"
        :course="course"
        :session="session"
      />
    </template>

    <div class="grid gap-4">
      <course-page-registration-actions :course="course" :session="session" />

      <p v-if="session.organization" class="text-center text-xs">
        <strong>{{
          $t("course.page.next_session_enrolment.related_organization_label")
        }}</strong>
        <app-image
          :alt="session.organization.name"
          class="mx-auto mt-2"
          :height="35"
          :src="session.organization.logo_url"
        />
      </p>

      <p v-else-if="subtitle" class="text-subtle text-center text-xs">
        {{ subtitle }}
      </p>
    </div>
  </app-panel>
</template>

<script lang="ts" setup>
import type { CoursePageView } from "~/business-areas/course/course.model";
import type { CourseSessionView } from "~/business-areas/course-session/course-session.model";

import CoursePageRegistrationActions from "./course-page-registration-actions.vue";
import CoursePageSessionChipInfo from "./course-page-session-chip-info.vue";

const properties = defineProps<{
  course: CoursePageView;
  session: CourseSessionView;
}>();

const { isRegisteredToCourseSession } = useLearnerProfile();

const { t } = useI18n();

const subtitle = computed(() => {
  if (!properties.session) return;

  if (isRegisteredToCourseSession(properties.session.id)) return;

  return t("course.page.registration_limit_date", {
    date: useI18nDate(properties.session.registrationLimitDate, {
      month: "short",
      day: "numeric",
      timeZone: properties.session.timezone,
    }).value,
  });
});
</script>
